import React from 'react';

// DESIGN V2 — the ONE row every tool list is made of (Loudness, Compatibility;
// Metadata's table rows and Organize's tree nodes take the same classes).
//
//   [cover/play] [status] name ……………………… middle (bar / reason / old→new) … [action] [⋯]
//
// The row owns: height, hairline, hover, selection, keyboard, truncation and
// where the error line goes. A tool passes its data and two things of its
// own: `middle` (what the row shows) and `action` (what the row can do).
export default function ToolRow({
    rowKey, status = '', selected = false, className = '',
    onClick, onContextMenu, onDoubleClick,
    cover, dot, name, nameTitle, note, detail, middle, number, action, menu,
}) {
    return (
        <div
            data-rowkey={rowKey}
            className={`log-entry v2-tool-row ${className} ${status} ${selected ? 'selected-row' : ''}`}
            onClick={onClick}
            onMouseDown={(e) => { if (e.shiftKey) e.preventDefault(); }}
            onContextMenu={onContextMenu}
            onDoubleClick={onDoubleClick}
            role="row"
            aria-selected={selected || undefined}
        >
            {cover}
            {dot}
            <span className="v2-row-name" title={nameTitle}>
                {name}
                {note}
                {detail && <span className="v2-row-detail"> — {detail}</span>}
            </span>
            {middle}
            {number != null && <span className="v2-row-num v2-num">{number}</span>}
            {/* A list that offers per-row actions passes `action` on every row
                (null where there is none), so the slot keeps its width and the
                format column and ⋯ line up down the list. */}
            {action !== undefined && <span className="v2-row-action">{action || null}</span>}
            {menu}
        </div>
    );
}
